// packages/shared/src/hooks/useGetUserTypes.js
import { useEffect, useState, useCallback, useRef } from 'react';
import fetchUserTypes from '../data/fetchUserTypes';

export default function useGetUserTypes(token, { skip = false } = {}) {
  const [data, setData] = useState(null); // { settings, types } or just [types]
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);

  const load = useCallback(async () => {
    if (!token) return null;
    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;

    setLoading(true);
    setError(null);
    try {
      const payload = await fetchUserTypes(token, {
        signal: controller.signal,
      });
      setData(payload);
      return payload;
    } catch (e) {
      if (e.name !== 'AbortError') setError(e);
      return null;
    } finally {
      if (!controller.signal.aborted) setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (!skip) load();
    return () => abortRef.current?.abort();
  }, [load, skip]);

  return { data, loading, error, refetch: load };
}
